import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { ClickOutside } from "./directives/click-outside.js";
import { Plugin } from "vue-fragment";
import { IconsPlugin } from "@/plugins/icons-plugin";
import "./main.css";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText }
 from '@fortawesome/vue-fontawesome'

library.add(fas, far, fab)
 
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.directive("click-outside", ClickOutside);
Vue.use(IconsPlugin);
Vue.use(Plugin);
Vue.config.productionTip = false;

document.title = 'Yuxuan PANG\'s Website';

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
